export enum FeaturesEnabler {
    CONVERT_TO_PDF = 'convertToPdf'
}

export const QUERY_PARAM_FEATURE_ENABLED_KEY = 'enabled';
